import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import Title from "../../Title/Title";
import { useDelete, useFetch, useFilter } from "../../../ApiS";
import { useParams } from "react-router-dom";
import Add from "../../Buttons/Add";
import { useState } from "react";
import { IoMdAdd } from "react-icons/io";
import PopUp from "../../PopUp";
import { Dialog } from "../../ui/Dialog";
import Search from "../../Search/Search";
import Table, { TableOperation } from "../../Table";
import { RiEditBoxFill } from "react-icons/ri";
import { FaEye, FaRegTrashAlt } from "react-icons/fa";
import { usePopUpsStore } from "../../../store/PopUpStore";
import Pagination from "../../pagination/Pagination (1)";
import PopUpDelete from "../../PopUps/PopUpDelete (1)";
import Loader from "../../Loader";

interface AcadimecFeeData {
  data: { data: AcadimecFee[]; last_page: number };
}

interface AcadimecFee {
  id: number;
  curriculum_id: string;
  student_year: string;
  fee: number;
  student_registrations_count: number;
}

export default function AcadimecFee() {
  const operations: TableOperation[] = [
    {
      name: "show",
      icon: FaEye,
      link: true,
      onClick: () => {
        console.log("View");
      },
    },
    {
      name: "edit",
      icon: RiEditBoxFill,
      link: true,
      onClick: () => {
        console.log("edit");
      },
    },
    {
      name: "delete",
      icon: FaRegTrashAlt,
      link: true,
      onClick: (id) => {
        setPopUpDelete([id, true]);
      },
    },
  ];
  const [create, setCreate] = useState<boolean>(false);
  const { setPopUpDelete, popUpDelete } = usePopUpsStore();

  const { id } = useParams();

  const { data , isLoading } = useFetch(
    `admin/semesters/${id}/academic-fees`,
    "academic-fees"
  );
  const { mutation, deleteItem } = useDelete(
    () => window.location.reload(),
    () => console.log(mutation.error)
  );

  console.log(data);

  return isLoading ? <Loader/> : (
    <>
      <Row>
        <Col lg={4} className="flex justify-center" >
          <Title title="الرسوم الدراسية" />
        </Col>
      </Row>
      <Row justify="center">
        <Col lg={8} className="flex justify-end">
          <Search
            placeholder=" اسم الخصم"
            className=" border-2 border-[#efc5e6]"
          />
        </Col>
      </Row>
      <Row justify="center">
      
          <Table<AcadimecFee>
            tableHeads={[
              "رقم المقرر",
              "رقم البند",
              "السنة الدراسية",
              " الرسوم",
              "عدد سنوات تسجيل الطالب",
              "العمليات",
            ]}
            tableBody={data?.data?.data}
            keys={[
              "curriculum_id",
              "id",
              "student_year",
              "fee",
              "student_registrations_count",
            ]}
            operations={operations}
            className="lg:min-w-[100px] md:min-w-[30px]"
          />
       
      </Row>
      {data?.data?.data?.length > 0 &&  <Pagination pageCount={data?.data?.last_page} /> }

      <PopUpDelete
        text="هل أنت متأكد من حذف هذا البند"
        onClickDelete={() => {
          deleteItem(`admin/semesters/${id}/academic-fees/${popUpDelete[0]}`);
          mutation.isLoading && <Loader />;
        }}
      />

      <Add link={`/new_semester/${id}/academic-fees`} />
    </>
  );
}
